import { _ } from "../../../core/polyglot/polyglot.js";
import { formatAsShortDate } from "../../../core/helpers/date-formatting-util.js";
import { formatCurrency } from "../../../core/helpers/currency-formatting-util.js";
import companyChartLegendItemWidget from "./companyChartLegendItemWidget.js";
import popoverWidget from "../../../core/widgets/popoverWidget/popoverWidget.js";

/**
 * Company legend item for the assets.
 * The different items in the company chart legend have different colors and pop overs. So that is why we need this.
 */
function companyChartAssetsLegendItemWidget(spec, my) {
	spec ||= {};
	my ||= {};

	spec = Object.assign(spec, {
		title: _("Assets"),
		legendItemClass: "legend-item-assets",
		seriesId: "assets",
		valueRenderer: formatCurrency,
	});

	const that = companyChartLegendItemWidget(spec, my);

	/**
	 * @param {companyBalance} companyBalance - CompanyBalance to show in the popover
	 */
	my.createPopover = function (companyBalance) {
		const dateString = formatAsShortDate(companyBalance.date);

		return popoverWidget({
			header: function (html) {
				html.span(dateString, ", ", _("Assets"));
			},
			content: function (html) {
				html.label(
					{ class: "key-val-pair" },
					_("Current assets"),
					html.span(formatCurrency(companyBalance.currentAssets)),
				);

				html.label(
					{ class: "key-val-pair" },
					_("Fixed assets"),
					html.span(formatCurrency(companyBalance.fixedAssets)),
				);

				html.label(
					{ class: "key-val-pair" },
					_("Sum"),
					html.span(formatCurrency(companyBalance.totalAssets)),
				);
			},
		});
	};

	return that;
}

export default companyChartAssetsLegendItemWidget;
